// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-template-container {
  padding: 6px 12px 6px 45px;
  display: inline-block;
  width: 100%;
  animation-name: left-to-right-slide-anim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.button-template-container .button-temp {
  display: flex;
  flex-wrap: wrap;
  transition: 0.2s all ease;
}
.button-template-container .button-temp.full-width-buttons {
  flex-direction: column;
}
.button-template-container .button-temp.stack-buttons {
  display: block;
}
.button-template-container .button-temp.stack-buttons .kr-btn {
  display: block;
  width: auto;
  margin-bottom: 8px;
}
.button-template-container .button-temp.button-variation-1 .kr-btn {
  background: var(--button-temp-bg-variation-1);
  border: 1px solid var(--button-temp-variation-1-border);
  color: var(--button-temp-variation-1-color);
}
.button-template-container .button-temp.button-variation-1 .kr-btn:hover {
  background: var(--button-temp-bg-variation-1-hover);
}
.button-template-container .button-temp.button-variation-2 .kr-btn {
  background: var(--button-temp-bg-variation-2);
  border: 1px solid var(--button-temp-variation-2-border);
  color: var(--button-temp-variation-2-color);
}
.button-template-container .button-temp.button-variation-2 .kr-btn:hover {
  background: var(--button-temp-bg-variation-2-hover);
}
.button-template-container .button-temp .kr-btn {
  background: var(--button-temp-bg);
  border: 1px solid var(--button-temp-border);
  border-radius: 4px;
  padding: 9px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--button-temp-color);
  cursor: pointer;
  margin: 4px;
  text-align: center;
  transition: 0.2s all ease;
}
.button-template-container .button-temp .kr-btn:hover {
  background: var(--button-temp-bg-hover);
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/button/button.scss"],"names":[],"mappings":"AAEA;EACI,0BAAA;EACA,qBAAA;EACA,WAAA;EACA,wCAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AADJ;AAEI;EACI,aAAA;EACA,eAAA;EACA,yBAAA;AAAR;AACQ;EACI,sBAAA;AACZ;AACQ;EACI,cAAA;AACZ;AAAY;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AAEhB;AAEY;EACI,6CAAA;EACA,uDAAA;EACA,2CAAA;AAAhB;AACgB;EACI,mDAAA;AACpB;AAIY;EACI,6CAAA;EACA,uDAAA;EACA,2CAAA;AAFhB;AAGgB;EACI,mDAAA;AADpB;AAKQ;EACI,iCAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAHZ;AAIY;EACI,uCAAA;AAFhB","sourcesContent":["// Button Template\n\n.button-template-container{\n    padding: 6px 12px 6px 45px;\n    display: inline-block;\n    width: 100%;\n    animation-name: left-to-right-slide-anim;\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    opacity: 0;\n    .button-temp{\n        display: flex;\n        flex-wrap: wrap;\n        transition: 0.2s all ease;\n        &.full-width-buttons{\n            flex-direction: column;\n        }\n        &.stack-buttons{\n            display: block;\n            .kr-btn{\n                display: block;\n                width: auto;\n                margin-bottom: 8px;\n            }\n        }\n        &.button-variation-1{\n            .kr-btn{\n                background: var(--button-temp-bg-variation-1);\n                border: 1px solid var(--button-temp-variation-1-border);\n                color: var(--button-temp-variation-1-color);\n                &:hover{\n                    background: var(--button-temp-bg-variation-1-hover);\n                }\n            }\n        }\n        &.button-variation-2{\n            .kr-btn{\n                background: var(--button-temp-bg-variation-2);\n                border: 1px solid var(--button-temp-variation-2-border);\n                color: var(--button-temp-variation-2-color);\n                &:hover{\n                    background: var(--button-temp-bg-variation-2-hover);\n                }\n            }\n        }\n        .kr-btn{\n            background: var(--button-temp-bg);\n            border: 1px solid var(--button-temp-border);\n            border-radius: 4px;\n            padding: 9px 16px;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 17px;\n            color: var(--button-temp-color);\n            cursor: pointer;\n            margin: 4px;\n            text-align: center;\n            transition: 0.2s all ease;\n            &:hover{\n                background: var(--button-temp-bg-hover);\n            }\n        }\n    }\n}\n\n// End"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
